/** Entspricht IndicatorEnum der API (numerisch serialisiert, RPA-1479). */
export enum SchemaIndicatorEnum {
    Undef = 0,
    Off = 1,
    On = 2,
    Flash = 3
}
